// bill_subsystem_v1 + status_workflow_v1 + invoice_crud_v1: invoices CRUD with send-to-customer + print
import React, { useState, useEffect } from 'react';
import API from '../api';
import BillInvoiceForm from './BillInvoiceForm';
import BillInvoiceSendModal from './BillInvoiceSendModal';
import InvoiceImageModal from './InvoiceImageModal'; /* invoice_image_v1 */
import SlipReviewModal from './SlipReviewModal'; /* payment_slip_agent_v1 */
import { connectSSE } from '../../lib/sse'; /* slip_upload_sse_v1 */

function fmtMoney(n, cur) {
  var s = Number(n || 0).toLocaleString('th-TH', { minimumFractionDigits: 2 });
  return cur === 'USDT' ? (s + ' USDT') : ('฿' + s);
}

function fmtDate(d) {
  if (!d) return '-';
  try { return new Date(d).toLocaleDateString('th-TH', { year: 'numeric', month: 'short', day: 'numeric' }); }
  catch (e) { return d; }
}

function StatusBadge(props) {
  var map = {
    draft: { bg: '#f1f5f9', fg: '#475569', label: 'ร่าง' },
    sent: { bg: '#dbeafe', fg: '#1d4ed8', label: 'ส่งแล้ว' },
    viewed: { bg: '#e0e7ff', fg: '#4338ca', label: '👁️ ลูกค้าดู' }, /* status_workflow_v1 */
    paid: { bg: '#dcfce7', fg: '#15803d', label: 'จ่ายแล้ว' },
    overdue: { bg: '#fed7aa', fg: '#c2410c', label: 'เกินกำหนด' },
    cancelled: { bg: '#fee2e2', fg: '#b91c1c', label: 'ยกเลิก' },
  };
  var c = map[props.status] || { bg: '#f1f5f9', fg: '#475569', label: props.status || '-' };
  return <span style={{ background: c.bg, color: c.fg, padding: '2px 8px', borderRadius: 8, fontSize: 11, fontWeight: 600 }}>{c.label}</span>;
}

/* invoice_image_v1: wrapper that loads items before showing modal */
function ImageModalWrapper(props) {
  const [items, setItems] = React.useState(null);
  const [error, setError] = React.useState('');
  React.useEffect(function () {
    var API = require('../api').default;
    API.get('/api/invoices/' + props.invoice.id).then(function (r) {
      setItems(r.data.items || []);
    }).catch(function (e) { setError('Failed to load items'); });
  }, [props.invoice.id]);
  if (error) return <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100 }}><div style={{ background: 'white', padding: 20, borderRadius: 10 }}>⚠️ {error} <button onClick={function () { props.onClose(false); }}>ปิด</button></div></div>;
  if (!items) return <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, color: 'white' }}>กำลังโหลด...</div>;
  return <InvoiceImageModal invoice={props.invoice} items={items} onClose={props.onClose} />;
}

export default function BillInvoices() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  /* invoice_duedate_filter_v1: month/date range filter by due_date */
  const [monthFilter, setMonthFilter] = useState(function () { var d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0'); });
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [isOwner, setIsOwner] = useState(false); /* invoice_soft_delete_v1 */
  useEffect(function () { API.get('/api/bill/auth/me').then(function (r) { setIsOwner(!!(r.data && r.data.user && r.data.user.bill_role === 'owner')); }).catch(function () {}); }, []); /* invoice_soft_delete_v1 */
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [sendModal, setSendModal] = useState(null);
  const [imageModal, setImageModal] = useState(null); /* invoice_image_v1 */
  const [slipModal, setSlipModal] = useState(null); /* payment_slip_agent_v1 */
  function openSlip(inv) { setSlipModal(inv); }
  function closeSlip(reload) { setSlipModal(null); if (reload) load(); }
  /* slip_upload_sse_v1: real-time แจ้งเมื่อลูกค้าอัพสลิป */
  const [slipToast, setSlipToast] = useState(null);
  const [highlightSlipId, setHighlightSlipId] = useState(null); /* slip_upload_highlight_v1 */
  useEffect(function () {
    var billToken = localStorage.getItem('bill_token');
    if (!billToken) return undefined;
    var conn = connectSSE({
      token: billToken,
      onSlipUploaded: function (d) {
        setHighlightSlipId(d && d.invoiceId ? d.invoiceId : null); /* slip_upload_highlight_v1 */
        setSlipToast('\uD83D\uDD14 ' + ((d && d.customer) || '\u0e25\u0e39\u0e01\u0e04\u0e49\u0e32') + ' \u0e2d\u0e31\u0e1e\u0e2a\u0e25\u0e34\u0e1b ' + ((d && d.invoiceNo) || ''));
        load();
        setTimeout(function () { setSlipToast(null); }, 6000);
      }
    });
    return function () { conn.close(); };
  }, []);
  /* usdt_default_rate_v1: per-tenant USDT rate (today) */
  const [usdtDefaultRate, setUsdtDefaultRate] = useState(null);
  const [rateInput, setRateInput] = useState('');
  const [savingRate, setSavingRate] = useState(false);
  const [rateMessage, setRateMessage] = useState('');
  /* usdt_default_wallet_v1: default wallet + network */
  const [walletInput, setWalletInput] = useState('');
  const [networkInput, setNetworkInput] = useState('');
  const [savingWallet, setSavingWallet] = useState(false);
  const [walletMessage, setWalletMessage] = useState('');

  function load() {
    setLoading(true);
    API.get('/api/invoices')
      .then(function (r) {
        var data = Array.isArray(r.data) ? r.data : ((r.data && r.data.invoices) || []);
        setInvoices(data);
      })
      .catch(function () {})
      .finally(function () { setLoading(false); });
  }

  /* usdt_default_rate_v1: load + save USDT rate (today) */
  function loadUsdtRate() {
    API.get('/api/bill/settings/usdt-rate')
      .then(function (r) {
        var rate = r.data && r.data.rate;
        setUsdtDefaultRate(rate);
        setRateInput(rate ? String(rate) : '');
      })
      .catch(function () {});
  }
  async function handleSaveRate() {
    var n = Number(rateInput);
    if (!isFinite(n) || n <= 0) {
      setRateMessage('⚠️ กรอกตัวเลข > 0');
      setTimeout(function () { setRateMessage(''); }, 3000);
      return;
    }
    setSavingRate(true);
    setRateMessage('');
    try {
      var r = await API.patch('/api/bill/settings/usdt-rate', { rate: n });
      setUsdtDefaultRate(r.data && r.data.rate);
      /* usdt_default_rate_v1_recalc_ui: show count + reload */
      var recalced = (r.data && typeof r.data.recalced_drafts === 'number') ? r.data.recalced_drafts : 0;
      setRateMessage('✅ บันทึก' + (recalced > 0 ? 'และอัพเดท ' + recalced + ' บิล draft' : ''));
      if (recalced > 0) { load(); }
      setTimeout(function () { setRateMessage(''); }, 3000);
    } catch (e) {
      setRateMessage('❌ บันทึกไม่สำเร็ช');
      setTimeout(function () { setRateMessage(''); }, 3000);
    } finally {
      setSavingRate(false);
    }
  }
  /* usdt_default_wallet_v1: load default wallet */
  function loadUsdtWallet() {
    API.get('/api/bill/settings/usdt-wallet').then(function (r) {
      setWalletInput((r.data && r.data.wallet) ? String(r.data.wallet) : '');
      setNetworkInput((r.data && r.data.network) ? String(r.data.network) : '');
    }).catch(function () {});
  }
  function handleSaveWallet() {
    setSavingWallet(true);
    setWalletMessage('');
    API.patch('/api/bill/settings/usdt-wallet', { wallet: walletInput, network: networkInput }).then(function () {
      setWalletMessage('✅ บันทึก');
      setTimeout(function () { setWalletMessage(''); }, 3000);
    }).catch(function (e) {
      setWalletMessage('⚠️ ' + ((e.response && e.response.data && e.response.data.error) || 'บันทึกไม่สำเร็จ'));
      setTimeout(function () { setWalletMessage(''); }, 3000);
    }).finally(function () { setSavingWallet(false); });
  }
  useEffect(function () { load(); loadUsdtRate(); loadUsdtWallet(); }, []);

  function openCreate() { setEditing(null); setShowForm(true); }
  function openEdit(inv) { setEditing(inv); setShowForm(true); }
  function closeForm(reload) { setShowForm(false); setEditing(null); if (reload) load(); }

  /* status_workflow_v1: new status actions */
  async function handleMarkViewed(inv) {
    if (!window.confirm('มาร์คบิล ' + inv.invoice_number + ' ว่าลูกค้าดูแล้ว?')) return;
    try { await API.patch('/api/invoices/' + inv.id + '/mark-viewed'); load(); }
    catch (e) { alert('ผิดพลาด: ' + ((e.response && e.response.data && e.response.data.error) || '')); }
  }
  async function handleRevertDraft(inv) {
    if (!window.confirm('กลับเป็น draft? (สำหรับแก้ไขใหม่ — ยกเลิก sent_at)')) return;
    try { await API.patch('/api/invoices/' + inv.id + '/revert-draft'); load(); }
    catch (e) { alert('ผิดพลาด: ' + ((e.response && e.response.data && e.response.data.error) || '')); }
  }

  function openSend(inv) { setSendModal(inv); }
  function closeSend(reload) { setSendModal(null); if (reload) load(); }
  /* invoice_image_v1: image preview modal */
  function openImage(inv) { setImageModal(inv); }
  function closeImage(reload) { setImageModal(null); if (reload) load(); }

  async function handleMarkPaid(inv) {
    if (!window.confirm('ยืนยันว่า "' + inv.invoice_number + '" ได้รับเงินแล้ว?')) return;
    try {
      await API.patch('/api/invoices/' + inv.id + '/mark-paid');
      load();
    } catch (err) {
      alert((err.response && err.response.data && err.response.data.error) || 'อัปเดตไม่สำเร็จ');
    }
  }

  async function handleCancel(inv) {
    /* cancel_paid_v1: paid -> เตือนแรงขึ้น */
    var msg = inv.status === 'paid'
      ? 'บิลนี้ "จ่ายแล้ว" — ยกเลิกจะหักยอดรับเงินออกจากสถิติลูกค้า และกู้คืนไม่ได้ ยืนยันยกเลิกใบ "' + inv.invoice_number + '"?'
      : 'ยกเลิกใบ "' + inv.invoice_number + '"?';
    if (!window.confirm(msg)) return;
    try {
      await API.patch('/api/invoices/' + inv.id + '/cancel');
      load();
    } catch (err) {
      alert((err.response && err.response.data && err.response.data.error) || 'ยกเลิกไม่สำเร็จ');
    }
  }

  async function handlePrint(inv) {
    /* print_blob_v1: fetch ด้วย bill_token (axios) -> blob -> เปิดแท็บใหม่ (เลี่ยงปัญหา window.open ไม่ส่ง auth header) */
    try {
      const r = await API.get('/api/invoices/' + inv.id + '/print-view', { responseType: 'text' });
      const blob = new Blob([r.data], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      const w = window.open(url, '_blank');
      if (!w) { alert('โปรดอนุญาต popup ของเว็บนี้'); }
      setTimeout(function () { try { URL.revokeObjectURL(url); } catch (e) {} }, 60000);
    } catch (err) {
      alert((err.response && err.response.data && err.response.data.error) || 'เปิดใบเสร็จไม่สำเร็จ');
    }
    return; /* print_blob_v1: end (บรรทัดเดิมด้านล่างเป็น dead code) */
    // legacy_disabled_print_blob_v1:
    // window.open('/api/invoices/' + inv.id + '/print-view', '_blank') || alert('โปรดอนุญาต popup ของเว็บนี้');  /* print_blob_v1: disabled */
  }

  /* invoice_duedate_filter_v1: scope by due_date (range overrides month) */
  function ymOf(d) { if (!d) return ''; var s2 = String(d).slice(0, 7); return s2; }
  var monthOptions = [];
  /* invoice_duedate_fallback_v1: ไม่มี due_date → ใช้ issue_date แทน (บิลจะได้ไม่หายจากตัวกรอง) */
  (function () { var seen = {}; invoices.forEach(function (i) { var ym = ymOf(i.due_date || i.issue_date); if (ym && !seen[ym]) { seen[ym] = 1; monthOptions.push(ym); } }); monthOptions.sort().reverse(); })();
  var rangeActive = !!(dateFrom || dateTo);
  var scoped = invoices.filter(function (i) {
    var basis = i.due_date || i.issue_date;
    var dd = basis ? String(basis).slice(0, 10) : '';
    if (rangeActive) {
      if (!dd) return false;
      if (dateFrom && dd < dateFrom) return false;
      if (dateTo && dd > dateTo) return false;
      return true;
    }
    if (monthFilter === 'all') return true;
    return ymOf(i.due_date || i.issue_date) === monthFilter;
  });
  function monthLabel(ym) { if (ym === 'all') return 'ทุกเดือน'; var p = ym.split('-'); var names = ['ม.ค.','ก.พ.','มี.ค.','เม.ย.','พ.ค.','มิ.ย.','ก.ค.','ส.ค.','ก.ย.','ต.ค.','พ.ย.','ธ.ค.']; return names[Number(p[1]) - 1] + ' ' + (Number(p[0]) + 543); }
  /* invoice_duedate_filter_v1: hoist-fixed */
  var filtered = scoped; /* invoice_duedate_filter_v1: was invoices */
  if (statusFilter !== 'all') {
    filtered = filtered.filter(function (i) { return i.status === statusFilter; });
  }
  if (search.trim()) {
    var q = search.trim().toLowerCase();
    filtered = filtered.filter(function (i) {
      return ((i.invoice_number || '').toLowerCase().indexOf(q) >= 0) ||
             ((i.recipient_name || '').toLowerCase().indexOf(q) >= 0);
    });
  }

  // Summary
  var sumOutstanding = scoped.filter(function (i) { return i.status === 'sent' || i.status === 'overdue'; }).reduce(function (s, i) { return s + Number(i.total_amount || 0); }, 0);
  var sumPaid = scoped.filter(function (i) { return i.status === 'paid'; }).reduce(function (s, i) { return s + Number(i.total_amount || 0); }, 0);
  /* invoice_usdt_summary_v1: USDT aggregates (scoped by invoice_duedate_filter_v1) */
  var sumOutstandingUsdt = scoped.filter(function (i) { return (i.status === 'sent' || i.status === 'overdue') && Number(i.total_amount_usdt || 0) > 0; }).reduce(function (s, i) { return s + Number(i.total_amount_usdt || 0); }, 0);
  var sumPaidUsdt = scoped.filter(function (i) { return i.status === 'paid' && Number(i.total_amount_usdt || 0) > 0; }).reduce(function (s, i) { return s + Number(i.total_amount_usdt || 0); }, 0);

  return (
    <div>
      {slipToast ? <div style={{ position: 'fixed', top: 20, right: 20, zIndex: 9999, background: '#10b981', color: '#fff', padding: '12px 18px', borderRadius: 10, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', fontWeight: 600, fontSize: 14, maxWidth: 320 }}>{slipToast}</div> : null}{/* slip_upload_sse_v1 */}
      <style>{'@keyframes slipPulse{0%,100%{box-shadow:0 0 0 0 rgba(239,68,68,.55)}50%{box-shadow:0 0 0 7px rgba(239,68,68,0)}}'}</style>{/* slip_upload_highlight_v1 */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20, gap: 12, flexWrap: 'wrap' }}>
        <h1 style={{ margin: 0, fontSize: 22 }}>ใบแจ้งหนี้</h1>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
          {/* invoice_duedate_filter_v1: month + date range (due_date) */}
          <select value={rangeActive ? 'custom' : monthFilter} onChange={function (e) { setDateFrom(''); setDateTo(''); setMonthFilter(e.target.value); }} style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, fontFamily: 'inherit' }} title='กรองตามวันครบกำหนด'>
            {rangeActive ? <option value='custom'>กำหนดเอง</option> : null}
            <option value='all'>ทุกเดือน</option>
            {monthOptions.map(function (ym) { return <option key={ym} value={ym}>{monthLabel(ym)}</option>; })}
          </select>
          <input type='date' value={dateFrom} onChange={function (e) { setDateFrom(e.target.value); }} style={{ padding: '7px 8px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, fontFamily: 'inherit' }} title='ครบกำหนด จากวันที่' />
          <span style={{ color: '#94a3b8', fontSize: 12 }}>–</span>
          <input type='date' value={dateTo} onChange={function (e) { setDateTo(e.target.value); }} style={{ padding: '7px 8px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, fontFamily: 'inherit' }} title='ครบกำหนด ถึงวันที่' />
          {rangeActive ? <button onClick={function () { setDateFrom(''); setDateTo(''); }} style={{ background: 'none', border: '1px solid #e2e8f0', padding: '7px 10px', borderRadius: 8, fontSize: 12, cursor: 'pointer', color: '#64748b' }}>ล้างวันที่</button> : null}
          <select value={statusFilter} onChange={function (e) { setStatusFilter(e.target.value); }} style={{ padding: '8px 10px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, fontFamily: 'inherit' }}>
            <option value="all">ทั้งหมด</option>
            <option value="draft">ร่าง</option>
            <option value="sent">ส่งแล้ว</option>
            <option value="paid">จ่ายแล้ว</option>
            <option value="overdue">เกินกำหนด</option>
            <option value="cancelled">ยกเลิก</option>
          </select>
          <input value={search} onChange={function (e) { setSearch(e.target.value); }} placeholder="ค้นหา..." style={{ width: 160, padding: '8px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, fontFamily: 'inherit' }} />
          <button onClick={openCreate} style={{ background: '#10b981', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>+ สร้างบิล</button>
        </div>
      </div>

      {!loading && ( /* usdt_box_always_v1: โชว์ stat cards + USDT box แม้บิล 0 */
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 12, marginBottom: 20 }}>
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: 11, color: '#64748b' }}>บิลทั้งหมด</div>
            <div style={{ fontSize: 20, fontWeight: 700 }}>{scoped.length}</div>
          </div>
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: 11, color: '#64748b' }}>ยอดค้างชำระ</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#f59e0b' }}>฿{Number(sumOutstanding).toLocaleString('th-TH', { minimumFractionDigits: 0 })}</div>
          </div>
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: 11, color: '#64748b' }}>รับเงินแล้ว</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#10b981' }}>฿{Number(sumPaid).toLocaleString('th-TH', { minimumFractionDigits: 0 })}</div>
          </div>
          {/* invoice_usdt_summary_v1: USDT outstanding + paid */}
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: 11, color: '#64748b' }}>ยอดค้างชำระ USDT</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#f59e0b' }}>{Number(sumOutstandingUsdt).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} <span style={{ fontSize: 12, color: '#94a3b8' }}>USDT</span></div>
          </div>
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #e2e8f0' }}>
            <div style={{ fontSize: 11, color: '#64748b' }}>รับเงินแล้ว USDT</div>
            <div style={{ fontSize: 20, fontWeight: 700, color: '#10b981' }}>{Number(sumPaidUsdt).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} <span style={{ fontSize: 12, color: '#94a3b8' }}>USDT</span></div>
          </div>
          {/* usdt_default_rate_v1: USDT rate today (editable) */}
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #fecaca' }}>
            <div style={{ fontSize: 11, color: '#dc2626', fontWeight: 600 }}>💱 USDT วันนี้ (1 USDT = ? THB)</div>
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 6 }}>
              <input
                type="number"
                min="0"
                step="0.01"
                value={rateInput}
                onChange={function (e) { setRateInput(e.target.value); }}
                placeholder="เช่น 36.50"
                style={{ flex: 1, minWidth: 0, padding: '6px 8px', borderRadius: 6, border: '1px solid #fecaca', fontSize: 14, color: '#dc2626', fontWeight: 700, fontFamily: 'inherit' }}
              />
              <button
                onClick={handleSaveRate}
                disabled={savingRate}
                style={{ background: '#dc2626', color: 'white', border: 'none', padding: '6px 10px', borderRadius: 6, fontSize: 12, cursor: savingRate ? 'wait' : 'pointer', fontWeight: 600, whiteSpace: 'nowrap' }}
              >{savingRate ? '...' : 'บันทึก'}</button>
            </div>
            {rateMessage ? (
              <div style={{ fontSize: 10, color: rateMessage.indexOf('✅') === 0 ? '#10b981' : '#dc2626', marginTop: 4 }}>{rateMessage}</div>
            ) : usdtDefaultRate ? (
              <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4 }}>ใช้เป็น default ตอนสร้างบิล</div>
            ) : (
              <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4 }}>ยังไม่ได้ตั้งค่า</div>
            )}
          </div>
          {/* usdt_default_wallet_v1: default wallet + network */}
          <div style={{ background: 'white', borderRadius: 10, padding: 14, border: '1px solid #c7d2fe' }}>
            <div style={{ fontSize: 11, color: '#4338ca', fontWeight: 600 }}>🪙 USDT Wallet (default)</div>
            <input value={walletInput} onChange={function (e) { setWalletInput(e.target.value); }} placeholder="wallet address" style={{ width: '100%', boxSizing: 'border-box', padding: '6px 8px', borderRadius: 6, border: '1px solid #c7d2fe', fontSize: 12, marginTop: 6, fontFamily: 'monospace' }} />
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginTop: 6 }}>
              <select value={networkInput} onChange={function (e) { setNetworkInput(e.target.value); }} style={{ flex: 1, minWidth: 0, padding: '6px 8px', borderRadius: 6, border: '1px solid #c7d2fe', fontSize: 13, fontFamily: 'inherit' }}>
                <option value="">— network —</option>
                <option value="TRC20">TRC20</option>
                <option value="ERC20">ERC20</option>
                <option value="BEP20">BEP20</option>
              </select>
              <button onClick={handleSaveWallet} disabled={savingWallet} style={{ background: '#4338ca', color: 'white', border: 'none', padding: '6px 10px', borderRadius: 6, fontSize: 12, cursor: savingWallet ? 'wait' : 'pointer', fontWeight: 600, whiteSpace: 'nowrap' }}>{savingWallet ? '...' : 'บันทึก'}</button>
            </div>
            {walletMessage ? (
              <div style={{ fontSize: 10, color: walletMessage.indexOf('✅') === 0 ? '#10b981' : '#dc2626', marginTop: 4 }}>{walletMessage}</div>
            ) : (
              <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 4 }}>ใช้เป็น default ตอนสร้างบิล</div>
            )}
          </div>
        </div>
      )}

      {loading ? (
        <div style={{ color: '#94a3b8' }}>กำลังโหลด...</div>
      ) : filtered.length === 0 ? (
        <div style={{ background: 'white', padding: 40, borderRadius: 12, textAlign: 'center', color: '#94a3b8', border: '1px solid #e2e8f0' }}>{invoices.length === 0 ? 'ยังไม่มีใบแจ้งหนี้ — กด "+ สร้างบิล"' : 'ไม่พบบิลที่ค้นหา'}</div>
      ) : (
        <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
            <thead>
              <tr style={{ background: '#f8fafc', textAlign: 'left' }}>
                <th style={{ padding: 12 }}>เลขที่</th>
                <th style={{ padding: 12 }}>ลูกค้า</th>
                <th style={{ padding: 12, textAlign: 'right' }}>ยอด</th>
                <th style={{ padding: 12, textAlign: 'center' }}>สถานะ</th>
                <th style={{ padding: 12 }}>ออกบิล</th>
                <th style={{ padding: 12 }}>ครบกำหนด</th>
                {/* invoice_usdt_display_v1: USDT column */}
                <th style={{ padding: 12, textAlign: 'right' }}>USDT</th>
                <th style={{ padding: 12, textAlign: 'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(function (inv) {
                var canEdit = inv.status === 'draft';
                var canSend = inv.status !== 'cancelled' && inv.status !== 'paid';
                var canMarkPaid = inv.status !== 'paid' && inv.status !== 'cancelled';
                var canCancel = inv.status !== 'cancelled'; /* cancel_paid_v1 */
                var canMarkViewed = inv.status === 'sent' || inv.status === 'overdue'; /* status_workflow_v1 */
                var canRevertDraft = inv.status !== 'draft' && inv.status !== 'paid'; /* status_workflow_v1 */
                return (
                  <tr key={inv.id} style={{ borderTop: '1px solid #f1f5f9' }}>
                    <td style={{ padding: 12, fontWeight: 500 }}>{inv.invoice_number}</td>
                    <td style={{ padding: 12 }}>
                      <div>{inv.recipient_name}</div>
                      {inv.recipient_phone ? <div style={{ fontSize: 11, color: '#94a3b8' }}>{inv.recipient_phone}</div> : null}
                    </td>
                    <td style={{ padding: 12, textAlign: 'right', fontWeight: 600 }}>{fmtMoney(inv.total_amount, inv.currency)}</td>
                    <td style={{ padding: 12, textAlign: 'center' }}><StatusBadge status={inv.status} /></td>
                    <td style={{ padding: 12, color: '#64748b', fontSize: 12 }}>{fmtDate(inv.issue_date)}</td>
                    <td style={{ padding: 12, color: '#64748b', fontSize: 12 }}>{fmtDate(inv.due_date)}</td>
                    {/* invoice_usdt_display_v1: USDT cell */}
                    <td style={{ padding: 12, textAlign: 'right', fontSize: 12, color: '#64748b', whiteSpace: 'nowrap' }}>
                      {inv.total_amount_usdt && Number(inv.total_amount_usdt) > 0 ? (
                        <div>
                          <div style={{ fontWeight: 600, color: '#475569' }}>
                            {Number(inv.total_amount_usdt).toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 4 })} USDT
                          </div>
                          {inv.usdt_rate ? <div style={{ fontSize: 10, color: '#94a3b8' }}>@ {Number(inv.usdt_rate).toLocaleString('th-TH')}</div> : null}
                        </div>
                      ) : <span style={{ color: '#cbd5e1' }}>—</span>}
                    </td>
                    <td style={{ padding: 12, textAlign: 'right', whiteSpace: 'nowrap' }}>
                      {canEdit ? <button onClick={function () { openEdit(inv); }} style={{ background: 'none', border: '1px solid #e2e8f0', padding: '4px 8px', borderRadius: 6, fontSize: 11, marginRight: 4, cursor: 'pointer' }}>แก้ไข</button> : null}
                      {canSend ? <button onClick={function () { openSend(inv); }} style={{ background: '#dbeafe', border: '1px solid #93c5fd', color: '#1d4ed8', padding: '4px 8px', borderRadius: 6, fontSize: 11, marginRight: 4, cursor: 'pointer' }}>📤 ส่ง</button> : null}
                      <button onClick={function () { openImage(inv); }} style={{ background: '#fef3c7', border: '1px solid #fcd34d', color: '#92400e', padding: '4px 8px', borderRadius: 6, fontSize: 11, marginRight: 4, cursor: 'pointer' }} title="ดูรูป+ส่ง">🖼️ รูป</button>
                      <button onClick={function () { setHighlightSlipId(null); openSlip(inv); }} style={inv.id === highlightSlipId ? { background: '#fee2e2', border: '2px solid #ef4444', color: '#b91c1c', padding: '3px 7px', borderRadius: 6, fontSize: 11, marginRight: 4, cursor: 'pointer', fontWeight: 700, animation: 'slipPulse 1.1s ease-out infinite' } : { background: '#f0fdf4', border: '1px solid #86efac', color: '#15803d', padding: '4px 8px', borderRadius: 6, fontSize: 11, marginRight: 4, cursor: 'pointer' }} title='ดู/อนุมัติสลิป'>{inv.id === highlightSlipId ? '🔔 สลิปใหม่' : '📤 สลิป'}</button>{/* slip_upload_highlight_v1 */}
                      <button onClick={function () { handlePrint(inv); }} style={{ background: 'none', border: '1px solid #e2e8f0', padding: '4px 8px', borderRadius: 6, fontSize: 11, marginRight: 4, cursor: 'pointer' }} title="พิมพ์/PDF">🖨️</button>
                      {canMarkPaid ? <button onClick={function () { handleMarkPaid(inv); }} style={{ background: '#dcfce7', border: '1px solid #86efac', color: '#15803d', padding: '4px 8px', borderRadius: 6, fontSize: 11, marginRight: 4, cursor: 'pointer' }}>✓ จ่ายแล้ว</button> : null}
                      {canMarkViewed ? <button onClick={function () { handleMarkViewed(inv); }} style={{ background: '#e0e7ff', border: '1px solid #a5b4fc', color: '#4338ca', padding: '4px 8px', borderRadius: 6, fontSize: 11, marginRight: 4, cursor: 'pointer' }} title="มาร์คว่าลูกค้าดูแล้ว">👁️</button> : null}
                      {canRevertDraft ? <button onClick={function () { handleRevertDraft(inv); }} style={{ background: 'none', border: '1px solid #cbd5e1', color: '#475569', padding: '4px 8px', borderRadius: 6, fontSize: 11, marginRight: 4, cursor: 'pointer' }} title="กลับเป็น draft">↩️</button> : null}
                      {canCancel ? <button onClick={function () { handleCancel(inv); }} style={{ background: 'none', border: '1px solid #fecaca', color: '#dc2626', padding: '4px 8px', borderRadius: 6, fontSize: 11, cursor: 'pointer' }}>ยกเลิก</button> : null}
                      {inv.status === 'cancelled' && isOwner ? <button onClick={function () { if (!window.confirm('ลบใบนี้? จะไม่แสดงในรายการอีก')) { return; } API.patch('/api/invoices/' + inv.id + '/soft-delete').then(function () { load(); }).catch(function (e) { alert((e.response && e.response.data && e.response.data.error) || 'ลบไม่สำเร็จ'); }); }} style={{ background: '#fee2e2', border: '1px solid #fecaca', color: '#b91c1c', padding: '4px 8px', borderRadius: 6, fontSize: 11, marginLeft: 4, cursor: 'pointer' }} title="ลบใบที่ยกเลิก">🗑️ ลบ</button> : null}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {showForm && <BillInvoiceForm invoice={editing} onClose={closeForm} />}
      {sendModal && <BillInvoiceSendModal invoice={sendModal} onClose={closeSend} />}
      {imageModal && <ImageModalWrapper invoice={imageModal} onClose={closeImage} />} {/* invoice_image_v1 */}
      {slipModal && <SlipReviewModal invoice={slipModal} onClose={closeSlip} />} {/* payment_slip_agent_v1 */}
    </div>
  );
}
